<script setup lang="ts">
definePageMeta({
  middleware: 'auth',
  alias: ['/stories.html']
})

const stories = useStoryStore();

onMounted(async () => {
  await stories.loadValues();
  console.trace(`Found ${stories.userStories?.length} stories`);
})

</script>

<template>
  <PageTitle
      :title="$t('stories.title')"
      :description="$t('stories.description')"
      :links="[
          {name: $t('menu.breadcrumbs.home'), link: '/'},
          ]"
      :current="$t('menu.breadcrumbs.stories')"
  />
  <section v-if="stories.isLoaded" class="featured-services section">
    <div class="container">
      <div class="row gy-5 d-flex justify-content-center">
        <StoryCard
            v-for="story in stories.userStories"
            :story="story"
        />
        <StoryCard
            :story="createEmptyStory()"
            :is-create-new="true"
        />
      </div>
    </div>
  </section>
  <section v-else class="text-center p-5 d-flex flex-column flex-grow-1 align-items-center justify-content-center">
    <div class="loading spinner-border text-warning"></div>
  </section>
</template>

<style scoped>

section {
  flex-grow: 1;
}
/*--------------------------------------------------------------
# Featured Services Section
--------------------------------------------------------------*/
.featured-services .img {
  border-radius: 8px;
  overflow: hidden;
}

.featured-services .img img {
  transition: 0.6s;
}

.featured-services .details {
  background: color-mix(in srgb, var(--surface-color), transparent 5%);
  padding: 50px 30px;
  margin: -25px 30px 0 30px;
  transition: all ease-in-out 0.3s;
  position: relative;
  text-align: center;
  border-radius: 8px;
  box-shadow: 0 0 25px rgba(0, 0, 0, 0.1);
}

.featured-services .details .icon {
  --size: 50px;
  width: var(--size);
  height: var(--size);
  background: var(--accent-color);
  color: var(--contrast-color);
  border: 4px solid var(--contrast-color);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  font-size: 28px;
  transition: ease-in-out 0.3s;
  position: absolute;
  top: calc(var(--size) / -2);
  left: calc(50% - (var(--size) / 2));
}

.featured-services .details h3 {
  font-weight: 700;
  margin: 10px 0 15px 0;
  font-size: 22px;
  transition: ease-in-out 0.3s;
}

.featured-services .details p {
  color: color-mix(in srgb, var(--default-color), transparent 10%);
  line-height: 24px;
  font-size: 14px;
  margin-bottom: 0;
}

.featured-services .service-item:hover .details h3 {
  color: var(--accent-color);
}

.featured-services .service-item .details .icon:hover {
  background: var(--surface-color);
  border: 2px solid var(--accent-color);
}

.featured-services .service-item .details .icon:hover i {
  color: var(--accent-color);
}

.featured-services .service-item:hover .img img {
  transform: scale(1.2);
}
</style>